import React, {memo} from "react";
import { Handle, useNodeConnections } from '@xyflow/react';

const handleStyle = {
  background: "grey", 
  width: '10px', 
  height: '10px'
};

const OneToOneHandle = (props) => {
  const connections = useNodeConnections({
    handleType: props.type,
    handleId: props.id
  });

  return (
    <Handle
      {...props}
      style={{...handleStyle, ...props.style}}
      isConnectable={connections.length < (props.condition === 1 ? 2 : 1)}
    />
  );
};

export default memo(OneToOneHandle);
